import { createContext, useContext, useState, useEffect } from 'react';
import { getMe } from '../utils/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('srg_token');
    if (token) {
      getMe()
        .then(data => setAdmin(data.admin))
        .catch(() => {
          localStorage.removeItem('srg_token');
          localStorage.removeItem('srg_admin');
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const loginSuccess = (token, adminData) => {
    localStorage.setItem('srg_token', token);
    localStorage.setItem('srg_admin', JSON.stringify(adminData));
    setAdmin(adminData);
  };

  const logout = () => {
    localStorage.removeItem('srg_token');
    localStorage.removeItem('srg_admin');
    setAdmin(null);
  };

  return (
    <AuthContext.Provider value={{ admin, loading, loginSuccess, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
